import { useEffect } from "react";
import { useCookieStore } from "../store/cookiestore";

// Loads the Facebook Pixel script for a given pixel ID
const loadPixel = (pixelId) => {
  if (window.fbq) return; // already loaded

  // Facebook Pixel base code
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js",
  );

  window.fbq("init", pixelId);
};

// Hook — call inside any page component that has a pixel_id
// with:
export function usePixel(pixels = []) {
  const cookieConsent = useCookieStore((s) => s.cookieConsent);

  useEffect(() => {

    if (!pixels?.length || cookieConsent !== true) {
      return;
    }

    pixels.forEach((pixel) => {
      if (pixel.type?.toLowerCase() === "facebook" && pixel.pixel_id) {
        loadPixel(pixel.pixel_id);
        window.fbq("track", "PageView");
      }
    });
  }, [JSON.stringify(pixels), cookieConsent]);

  // Helper to fire other events (AddToCart, Purchase etc.) later
  const trackEvent = (eventName, params = {}) => {
    if (!window.fbq || cookieConsent !== true) return;
    window.fbq("track", eventName, params);
  };

  return { trackEvent };
}
